module.exports = __webpack_public_path__ + "static/media/TileOTP.0e39e29c.png";